import React, {useEffect, useState} from 'react';
import {ref, getDatabase, onValue, set, child} from "firebase/database";
import app from "../firebaseConfig/firebaseConfig";
import CategoryCard from "./Components/CategoryCard";
import Button from "@mui/material/Button";
import {Trans} from "react-i18next";
import {useNavigate} from "react-router";

const db = getDatabase(app);
const categoriesRef = ref(db, 'categories');


function CategoryEditor(props) {
    const [categories, setCategories] = useState({});
    const navigate = useNavigate();

    useEffect(() => {
        onValue(categoriesRef, snapshot => {
            setCategories(snapshot.val() || {});
        })
    }, []);

    const storeCategory = (category, categoryId) => {
        set(child(categoriesRef, `/${categoryId}`), category);
    };

    const deleteCategory = (categoryId) => {
        set(child(categoriesRef, `/${categoryId}`), null);
    };

    return (
        <div className="categoryeditor">
            <Button sx={{mt: 2}} color={'secondary'} onClick={() => navigate('/admin')}>&lt; <Trans i18nKey={'buttons.back'}/></Button>

            <CategoryCard id={'new-category'} storeCategory={storeCategory} key={'new-category'}/>
            {Object.keys(categories).map(categoryId => <CategoryCard key={categoryId} id={categoryId} category={categories[categoryId]} storeCategory={storeCategory} deleteCategory={deleteCategory}/>)}
        </div>
    );
}

export default CategoryEditor;
